import { render, staticRenderFns } from "./StickerRemoveStickerButton.vue?vue&type=template&id=02ebc96a&scoped=true"
import script from "./StickerRemoveStickerButton.vue?vue&type=script&lang=ts"
export * from "./StickerRemoveStickerButton.vue?vue&type=script&lang=ts"
import style0 from "./StickerRemoveStickerButton.vue?vue&type=style&index=0&id=02ebc96a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ebc96a",
  null
  
)

export default component.exports